////////LIBRARY/////////
import update from 'immutability-helper'
import { cloneDeep, map, isUndefined } from 'lodash'
///////COMPONENTS///////
import extendUpdate from '../../helpers/extendUpdate'
import ActionsTypes from '../../constants/ActionsTypes'

extendUpdate(update)

const telecollectManager = {
	[ActionsTypes.GET_TELECOLLECTS]: (state) =>
		update(state, {
			telecollectManager: {
				isLoading: {
					$set: true,
				},
				items: {
					$set: [],
				},
			},
			columns: {
				currentDir: {
					$set: '',
				},
				currentColumn: {
					$set: '',
				},
			},
		}),
	[ActionsTypes.GET_TELECOLLECTS_SUCCESS]: (state, payload) => {
		const paging = {
			totalElements: payload.data.headerContent.contentPagined.totalElements,
			totalPages: payload.data.headerContent.contentPagined.totalPages,
		}

		return update(state, {
			telecollectManager: {
				isLoading: {
					$set: false,
				},
				items: {
					$set: payload.data.headerContent.contentPagined.content,
				},
				paging: {
					$set: paging,
				},
				header: {
					$set: payload.data.headerParam.filters,
				},
			},
		})
	},
	[ActionsTypes.GET_TELECOLLECTS_FAILURE]: (state, payload) =>
		update(state, {
			telecollectManager: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		}),
	[ActionsTypes.GET_TELECOLLECT_HEADER]: (state) =>
		update(state, {
			telecollectManager: {
				isLoading: {
					$set: true,
				},
				error: {
					$set: false,
				},
			},
		}),
	[ActionsTypes.GET_TELECOLLECT_HEADER_SUCCESS]: (state, payload) => {
		return update(state, {
			telecollectManager: {
				isLoading: {
					$set: false,
				},
				telecollectDetail: {
					$set: payload.telecollectHeader,
				},
				error: {
					$set: false,
				},
			},
		})
	},
	[ActionsTypes.GET_TELECOLLECT_HEADER_FAILURE]: (state, payload) =>
		update(state, {
			telecollectManager: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		}),
	[ActionsTypes.GET_TELECOLLECT_DETAIL_ITEMS]: (state) =>
		update(state, {
			telecollectManager: {
				isLoading: {
					$set: true,
				},
			},
		}),
	[ActionsTypes.GET_TELECOLLECT_DETAIL_ITEMS_SUCCESS]: (state, payload) => {
		let itemsExcluded = cloneDeep(state.telecollectManager.telecollectDetailItems.excluded)
		let itemsExcludedFilters = cloneDeep(state.telecollectManager.telecollectDetailItems.header.excluded)
		let itemsIncluded = cloneDeep(state.telecollectManager.telecollectDetailItems.included)
		let itemsIncludedFilters = cloneDeep(state.telecollectManager.telecollectDetailItems.header.included)

		if (payload.mode === 'excluded' || isUndefined(payload.mode)) {
			itemsExcluded = payload.data.excluded.data.headerContent.content.salesOrdersExcluded

			map(itemsExcluded, (elem) => {
				elem.visible = true
			})

			itemsExcludedFilters = payload.data.excluded.data.headerParam.filters
		}
		if (payload.mode === 'included' || isUndefined(payload.mode)) {
			itemsIncluded = payload.data.included.data.headerContent.content.salesOrdersIncluded

			map(itemsIncluded, (elem) => {
				elem.visible = true
			})

			itemsIncludedFilters = payload.data.included.data.headerParam.filters
		}

		return update(state, {
			telecollectManager: {
				telecollectDetailItems: {
					excluded: {
						$set: itemsExcluded,
					},
					included: {
						$set: itemsIncluded,
					},
					header: {
						included: {
							$set: itemsIncludedFilters,
						},
						excluded: {
							$set: itemsExcludedFilters,
						},
					},
				},
				isLoading: {
					$set: false,
				},
			},
		})
	},
	[ActionsTypes.GET_TELECOLLECT_DETAIL_ITEMS_FAILURE]: (state, payload) =>
		update(state, {
			telecollectManager: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		}),
	[ActionsTypes.GET_TELECOLLECT_DETAIL_SALE]: (state) =>
		update(state, {
			telecollectManager: {
				isLoading: {
					$set: true,
				},
				error: {
					$set: false,
				},
				sale: {
					$set: [],
				},
			},
		}),
	[ActionsTypes.GET_TELECOLLECT_DETAIL_SALE_SUCCESS]: (state, payload) => {
		// We want toggled line by default
		let arr = cloneDeep(payload.data)
		map(arr.salesOrderLines, (e) => (e.toggleNested = true))
		return update(state, {
			telecollectManager: {
				isLoading: {
					$set: false,
				},
				sale: {
					$set: [arr],
				},
				error: {
					$set: false,
				},
			},
		})
	},
	[ActionsTypes.GET_TELECOLLECT_DETAIL_SALE_FAILURE]: (state, payload) =>
		update(state, {
			telecollectManager: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		}),
	[ActionsTypes.SET_TELECOLLECT_COMPARISON]: (state) =>
		update(state, {
			telecollectManager: {
				isLoading: {
					$set: true,
				},
				update: {
					$set: false,
				},
			},
		}),
	[ActionsTypes.SET_TELECOLLECT_COMPARISON_SUCCESS]: (state, _payload) => {
		// Put new data in store ?

		return update(state, {
			telecollectManager: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: false,
				},
				update: {
					$set: true,
				},
				sale: {
					$set: [],
				},
				telecollectDetailItems: {
					$set: {
						included: [],
						excluded: [],
						header: {},
					},
				},
				telecollectDetail: {
					$set: {},
				},
			},
		})
	},
	[ActionsTypes.SET_TELECOLLECT_COMPARISON_FAILURE]: (state, payload) => {
		return update(state, {
			telecollectManager: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		})
	},
	[ActionsTypes.RESET_TELECOLLECT_ITEMS]: (state, _payload) => {
		return update(state, {
			telecollectManager: {
				items: {
					$set: [],
				},
				telecollectId: {
					$set: {},
				},
			},
		})
	},
	[ActionsTypes.GET_TELECOLLECT_TICKET]: (state) =>
		update(state, {
			telecollectManager: {
				isLoading: {
					$set: true,
				},
				error: {
					$set: false,
				},
			},
		}),
	[ActionsTypes.GET_TELECOLLECT_TICKET_SUCCESS]: (state, payload) => {
		return update(state, {
			telecollectManager: {
				isLoading: {
					$set: false,
				},
				telecollectTicket: {
					$set: payload.data,
				},
				error: {
					$set: false,
				},
			},
		})
	},
	[ActionsTypes.GET_TELECOLLECT_TICKET_FAILURE]: (state, payload) =>
		update(state, {
			telecollectManager: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		}),
}

export default telecollectManager
